(() => {
  const instances = new WeakMap();

  class ShippingBar {
    constructor(element) {
      console.log('ShippingBar Created');
      this.container = element;
      this.progressBar = element.querySelector('[data-fs-progress]');
      this.message = element.querySelector('[data-fs-message]');
      this.indicator = element.querySelector('[data-fs-indicator]');
      this.threshold = Math.round((parseFloat(element.dataset.threshold) || 0) * 100);
      this.currency = element.dataset.currency || 'USD';
      
      this.initialize();
    }

    async fetchCart() {
      try {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin'
        });

        if (!response.ok) throw new Error('Cart fetch failed');

        return await response.json();
      } catch (error) {
        console.error('[ShippingBar] Cart fetch error:', error);
        return null;
      }
    }

    async initialize() {
      if (!this.message || !this.progressBar) return;

      this.message.textContent = 'Checking your cart...';
      // this.progressBar.style.transform = 'translateX(-100%)';
      // this.progressBar.style.width = '0%';

      const cart = await this.fetchCart();

      if (cart) {
        this.updateProgress(cart);
      }

      this.setupEventListeners();
    }

    setupEventListeners() {
      if (this.listenersAttached) return;
      this.listenersAttached = true;

      document.addEventListener('shippingbar:refresh', async () => {
        const cart = await this.fetchCart();
        if (cart) this.updateProgress(cart);
      });
    }

    // updateProgress(cart) {
    //   if (!this.progressBar || !this.message) return;

    //   const total = cart.total_price || 0;
    //   const remaining = Math.max(0, this.threshold - total);
    //   const progress = Math.min(
    //     100,
    //     (total / this.threshold) * 100
    //   );

    //   this.progressBar.style.transform = `translateX(${progress - 100}%)`;

    //   const message =
    //     remaining > 0
    //       ? `Add ${this.formatMoney(remaining)} more for free shipping!`
    //       : `🎉 You've earned free shipping!`;

    //   if (this.message.textContent !== message) {
    //     this.message.textContent = message;
    //   }

    //   this.progressBar.classList.toggle(
    //     'fs-progress-pulse',
    //     progress > 80 && progress < 100
    //   );
    // }
    updateProgress(cart) {
        if (!this.progressBar || !this.message) return;

        const total = cart.total_price || 0;
        const remaining = Math.max(0, this.threshold - total);
        const progress = Math.min(
            100,
            (total / this.threshold) * 100
        );

        // this.progressBar.style.transform =`translateX(${progress - 100}%)`;
        this.progressBar.style.width = `${progress}%`;

        if (this.indicator) {
            const position = Math.min(Math.max(progress, 0), 100);
            this.indicator.style.left = `${position}%`;
            }
            console.log('Progress:', progress);
        const message =
            remaining > 0
            ? `Add ${this.formatMoney(remaining)} more for free shipping!`
            : `🎉 You've qualified for free shipping!`;

        this.message.textContent = message;
        }
    formatMoney(cents) {
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.currency
        }).format(cents / 100);
      } catch (e) {
        return `${this.currency} ${(cents / 100).toFixed(2)}`;
      }
    }

    cleanup() {
      instances.delete(this.container);
    }
  }

  function initializeBars(root = document) {
    root.querySelectorAll('[data-fs-bar]').forEach((element) => {
      if (!instances.has(element)) {
        instances.set(element, new ShippingBar(element));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeBars());
  } else {
    initializeBars();
  }

  if (!window.__shippingBarIntercepted) {
    window.__shippingBarIntercepted = true;

    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const response = await originalFetch.apply(window, args);

      try {
        const url = String(args[0]);

        if (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart.js')
        ) {
          setTimeout(() => {
            document.dispatchEvent(
              new CustomEvent('shippingbar:refresh')
            );
          }, 300);
        }
      } catch (e) {}

      return response;
    };

    const originalOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {
      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update')
      ) {
        this.addEventListener('load', () => {
          setTimeout(() => {
            document.dispatchEvent(
              new CustomEvent('shippingbar:refresh')
            );
          }, 300);
        });
      }

      return originalOpen.apply(this, arguments);
    };
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        if (node.matches?.('[data-fs-bar]')) {
          initializeBars(node.parentNode);
        } else {
          initializeBars(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', () => {
    initializeBars();
    document.dispatchEvent(
      new CustomEvent('shippingbar:refresh')
    );
  });
})();